import React from 'react';
import PropTypes from 'prop-types';
import { formatTimeFromSeconds } from '../../../core/util';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import ItemFormContainer from '../../item/components/ItemFormContainer';
import { startCase } from 'lodash';
import Tag from '../../../core/layout/Tag';
import AudioPreview from '../../../core/layout/AudioPreview';
import ImagePreview from '../../../core/layout/ImagePreview';
import { browserHistory } from 'react-router';

const PlacementTestItemList = (props) => (
  <Table
    fetching={props.fetching}
    rowClassName={(row) =>
      row.item.status === 'DRAFT' || row.item.status === 'UNPUBLISHED' ? 'table-row-dark' : 'table-row-light'
    }
    columns={[
      {
        label: 'Text',
        path: 'item.text',
        sort: true,
      },
      {
        label: 'Type',
        path: 'item.type.name',
        width: '150px',
        render: (cell, row) => (
          <>
            <Tag color={{ DRAFT: 'grey', PUBLISHED: 'green', UNPUBLISHED: 'red' }[row.item.status]}>
              {startCase(row.item.status.toLowerCase())}
            </Tag>
            {cell}
          </>
        ),
      },
      {
        label: 'Time',
        path: 'item.time',
        width: '105px',
        render: (cell, row) => formatTimeFromSeconds(row.item.time),
      },
      {
        label: 'Audio',
        path: 'item.audio',
        width: '70px',
        render: (cell, row) => (
          <>
            {!!cell && (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <AudioPreview src={cell} />
              </div>
            )}
            {row.item.answers && row.item.answers.length > 0 && row.item.answers.some((a) => a.audio) && (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: row.item.answers.filter((a) => a.audio).length > 1 ? '25px 25px' : '25px',
                  marginTop: 10,
                  gridGap: 5,
                  justifyContent: 'center',
                }}
              >
                {row.item.answers.map((a) => (a.audio ? <AudioPreview src={a.audio} size="sm" /> : null))}
              </div>
            )}
          </>
        ),
      },
      {
        label: 'Image',
        path: 'item.image',
        width: '190px',
        render: (cell, row) => (
          <>
            {!!cell && <ImagePreview src={cell} renderType="image" />}
            {row.item.answers && row.item.answers.length > 0 && row.item.answers.some((a) => a.image) && (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: row.item.answers.filter((a) => a.image).length > 1 ? '80px 80px' : '80px',
                  marginTop: cell ? 10 : 0,
                  gridGap: 5,
                  justifyContent: 'center',
                }}
              >
                {row.item.answers.map((a) =>
                  a.image ? <ImagePreview src={a.image} renderType="image" size="sm" /> : null
                )}
              </div>
            )}
          </>
        ),
      },
      {
        label: 'Actions',
        path: 'action',
        width: '120px',
        render: (cell, row) => {
          return (
            <div>
              {row.item.status === 'DRAFT' && (
                <>
                  <Button icon="delete" disabled={props.selectable} onClick={() => props.onDelete(row)} />{' '}
                  <Button icon="cloud-upload" disabled={props.selectable} onClick={() => props.onPublish(row)} />
                </>
              )}
              {row.item.status === 'PUBLISHED' && (
                <>
                  <Button icon="edit" disabled={props.selectable} onClick={() => props.onDraft(row.item)} />{' '}
                  <Button icon="cloud-download" disabled={props.selectable} onClick={() => props.onUnpublish(row)} />{' '}
                  {!!row.item.parent && (
                    <>
                      <Button
                        icon="history"
                        onClick={() =>
                          browserHistory.push(
                            `${browserHistory.getCurrentLocation().pathname}/items/${row.item.id}/history`
                          )
                        }
                      />{' '}
                    </>
                  )}
                </>
              )}
              {row.item.status === 'UNPUBLISHED' && (
                <Button icon="cloud-upload" disabled={props.selectable} onClick={() => props.onPublish(row)} />
              )}
            </div>
          );
        },
      },
    ]}
    idColumn="item.id"
    rows={props.items}
    expandable
    expandableComponent={(row) => {
      return (
        <div style={{ padding: '0px 10px' }}>
          <ItemFormContainer
            itemId={row.item.id}
            itemsTypeUrl="/item-types?allowedForPlacementTest=true"
            endpointUrl={`/grammar-placement-test-levels/${row.grammarPlacementTestLevel.id}/items`}
            order={null}
            disabled={row.item.status === 'PUBLISHED' || props.disabled}
            onSaveSuccess={props.onSaveSuccess}
            isTestItem
          />
        </div>
      );
    }}
  />
);

PlacementTestItemList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      grammarPlacementTestLevel: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
      item: PropTypes.shape({
        text: PropTypes.string,
        translation: PropTypes.string,
        grammar: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }),
      }),
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDraft: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  onUnpublish: PropTypes.func.isRequired,
};

export default PlacementTestItemList;
